import { Svg } from '@manomano-internal/tamagoshi-icons/esm/SvgOptimizer/Svg';

import { makeTamagoshiIcon } from '@/core/tamagoshiTailwind/util/makeTamagoshiComponent';

export const CategoryBathroomIcon = makeTamagoshiIcon((props, ref) => (
  <Svg
    height="24"
    optimizationId="tama-category-bathroom"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    ref={ref}
  >
    <path
      className="fill-accent-primaryActive"
      clipRule="evenodd"
      d="M4.75122 12.6472V4.57401C4.75122 3.15249 5.90371 2 7.32523 2C8.74686 2 9.89934 3.15249 9.89934 4.57401V5.04213H8.61234L8.61366 4.43289C8.61518 3.76619 8.07579 3.22477 7.40929 3.22365C6.74036 3.22244 6.19812 3.76579 6.20056 4.43462L6.23071 12.6472H4.75122Z"
      fillRule="evenodd"
    />
    <path
      className="fill-brand-primary"
      clipRule="evenodd"
      d="M9.78209 4.8136H8.68442C7.93701 4.8136 7.32544 5.42517 7.32544 6.17269V6.9604C7.32544 7.1601 7.48889 7.32365 7.68879 7.32365H10.7778C10.9776 7.32365 11.1412 7.1601 11.1412 6.9604V6.17269C11.1412 5.42517 10.5295 4.8136 9.78209 4.8136Z"
      fillRule="evenodd"
    />
    <path
      className="fill-brand-primary"
      clipRule="evenodd"
      d="M20.2488 12.9927H3.75143C3.3382 12.9927 3 12.6428 3 12.215V12.0744C3 11.6467 3.3382 11.2969 3.75143 11.2969H20.2488C20.662 11.2969 21 11.6467 21 12.0744V12.215C21 12.6428 20.662 12.9927 20.2488 12.9927Z"
      fillRule="evenodd"
    />
    <path
      className="fill-accent-primaryActive"
      clipRule="evenodd"
      d="M8.58424 19.094L8.46566 19.0256C8.10505 18.8174 7.63967 18.9421 7.43155 19.3027L6.59592 20.7501C6.3878 21.1106 6.51247 21.5759 6.87307 21.7842L6.99155 21.8526C7.35216 22.0608 7.81754 21.936 8.02577 21.5754L8.8613 20.1282C9.06952 19.7676 8.94485 19.3022 8.58424 19.094Z"
      fillRule="evenodd"
    />
    <path
      className="fill-accent-primaryActive"
      clipRule="evenodd"
      d="M17.479 21.7463L17.5878 21.6632C17.9186 21.4103 17.9826 20.9329 17.7299 20.602L16.7154 19.2739C16.4626 18.9431 15.9851 18.8792 15.6542 19.1319L15.5454 19.2149C15.2146 19.4678 15.1506 19.9453 15.4034 20.2762L16.4178 21.6042C16.6706 21.935 17.1481 21.999 17.479 21.7463Z"
      fillRule="evenodd"
    />
    <path
      className="fill-brand-primary"
      clipRule="evenodd"
      d="M16.2184 20.1568H7.78171C5.15176 20.1568 3 18.0002 3 15.3641V14.1361C3 13.8426 3.23965 13.6023 3.53257 13.6023H20.4675C20.7605 13.6023 21 13.8426 21 14.1361V15.3641C21 18.0002 18.8483 20.1568 16.2184 20.1568Z"
      fillRule="evenodd"
    />
  </Svg>
));

CategoryBathroomIcon.displayName = 'CategoryBathroomIcon';
